// extracted by mini-css-extract-plugin
export default {"exceptionWrapper":"CYZsIWfN"};